import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="container" style={{ color: '#EEEEF0' }}>

    <header className="header">
      <h1 className="text-center title">Privacy Policy</h1>
    </header>
    <p className="">Coming Soon!</p>
   
  

  </div>

  );
};

export default PrivacyPolicy;
